import { zkSync, zkSyncSepoliaTestnet } from 'wagmi/chains'
import { ConfigType } from '@config/types'
import { SlotType } from '@modules/inventory/store/avatar.store'
import { isStaging } from '@utils/isStaging'
import { SummonWallets } from '@utils/wallets'
import { ArtStyleEnum, AssetsPrefix, LevelUpVersion, Tenant } from '../enum'

const API_VERSION = 'v1/xps'

const DEFAULT_CONFIG: ConfigType = {
  name: Tenant.ZkSync,
  content: {
    login: {
      title: 'Libertas Omnibus',
      description:
        'Libertas Omnibus is an experimental NFT community project where power and status are granted to those who work for it.'
    }
  },
  assetsPrefix: AssetsPrefix.ZkSync,
  artStyle: ArtStyleEnum.Art3D,
  projectId: '59eebb948e528ff52ec8a70c2b7451f2',
  discordClientId: '1183036305031049216',
  network: isStaging ? zkSyncSepoliaTestnet : zkSync,
  isDarkMode: true,
  levelVersion: LevelUpVersion.V2,
  supportedChains: [isStaging ? zkSyncSepoliaTestnet : zkSync],
  wallets: [
    SummonWallets.metamask,
    SummonWallets.walletConnect,
    SummonWallets.trust,
    SummonWallets.okx,
    SummonWallets.zerion
  ],
  termsConfig: {
    termsOfServiceLink: 'https://game7.io/terms',
    privacyLink: 'https://game7.io/privacy',
    provider: Tenant.G7
  },
  api: {
    staging: {
      rest: `https://staging-zksync-api.summon.xyz/${API_VERSION}`,
      graphql: `https://staging-zksync-api.summon.xyz/${API_VERSION}/graphql`,
      tenantKey: '355932655192113587'
    },
    production: {
      rest: `https://zksync-api.summon.xyz/${API_VERSION}`,
      graphql: `https://zksync-api.summon.xyz/${API_VERSION}/graphql`,
      tenantKey: '355932655192113587'
    },
    shopify: {
      storeUrl: 'https://fce9b8-4.myshopify.com/api/2023-10/graphql.json',
      apiToken: '34a5fb7880f4fb22c46f4f8875851878',
      hero: {
        title: 'Welcome Libertas Omnibus Community!',
        subtitle: 'Pick up some physical swag for your journey. Merch only available to the LO community!'
      }
    }
  },
  features: {
    crafting: false,
    proposals: false,
    leaderboard: true,
    tokenGating: true,
    onChainItems: true,
    enableWeb2Auth: false,
    connect: {
      displayBar: false
    },
    enableShareAvatar: true,
    enableEditAvatar: true,
    warningMobileSupport: true,
    enableQuestPageCustomBgImg: false
  },
  meta: {
    title: 'ZkSync: A member-owned community',
    description: 'A member-owned community',
    ogTitle: 'ZkSync: A member-owned community',
    ogDescription:
      'ZkSync represents the final leg of the journey towards transitioning ETHDenver to a community owned ecosystem.',
    ogImage: 'open-graph-image.png'
  },

  analytics: {
    luckyOrangeTag: 'f46348cb'
  },
  sortedSlots: [
    SlotType.Headwear,
    SlotType.Eyewear,
    SlotType.Back,
    SlotType.Tops,
    SlotType.Legwear,
    SlotType.Footwear,
    SlotType.Body
  ],
  urlLinks: {
    wiki: 'https://zksync.mirror.xyz',
    support: 'https://discord.com/channels/722409280497516566/1167615661124624434'
  },
  lang: 'en',
  uiTheme: 'purple-rain'
}

export default DEFAULT_CONFIG
